module.exports = __webpack_public_path__ + "img/mission-gfp-wheat.png?897a967a87da511177ea697f9d8615dc";